export const categories = [
  "Glue gun",
  "Summer",
  "Art",
  "Beauty",
  "Cleaning",
  "Decor",
  "Woodworking",
  "Fashion",
  "Food",
  "Games",
  "Gift",
  "Health",
  "Hide",
  "Holiday",
  "Home",
  "Life Hacks",
  "Magic",
  "Men",
  "Phone",
  "Photography",
  "Pranks",
  "School",
  "Science",
  "Toys",
  "Travel",
  "Recycling",
  "Gadget",
  "Manly",
  "Restoration",
  "Cement",
  "Experience",
  "Handy",
  "3D Pen",
  "Resin",
  "Slime",
  "Car",
  "Tricks",
  "Drill",
  "Makeover",
  "Egg",
];

export const subcategories = [
  "Gluegun",
  "Flowers",
  "Art",
  "Home",
  "Fashion",
  "T-shirt",
  "Print",
  "Wall",
  "Jewelry",
  "Ring",
  "Hand",
  "Decoration",
  "Table",
  "Kitchen",
  "Cake",
  "Food",
  "Birthday",
  "Number",
  "Celebration",
  "Summer",
  "Hacks",
  "Popcorn",
  "Soda",
  "Cola",
  "Camping",
  "Health",
  "Phone",
  "Liquid",
  "Thermos",
  "Fishing",
  "Plate",
  "Picknic",
  "Fire",
  "Rubberband",
  "School",
  "Paper",
  "Soup",
  "Clothing",
  "Manly",
  "Measure",
  "Photo",
  "Paint",
  "Fruits",
  "Open",
  "Rubber band",
  "Kitchen",
  "Bottle",
  "Open",
  "Wine",
  "Cork",
  "Snack",
  "Shoes",
  "Summer",
  "3dpen",
  "Glasses",
  "Party",
  "Plastic",
  "Bookmark",
  "Arrow",
  "Cord",
  "Plug",
  "Holder",
  "Hole fill",
  "3dpen ",
  "Scissors",
  "Handle",
  "Zipper",
  "Bowl",
  "Light",
  "Luminaire",
  "Hood",
  "Spray paint",
  "Lamp",
  "Science",
  "Intro",
  "Experiment",
  "Recycling",
  "Reuse",
  "Egg",
  "Cleaning",
  "Dish",
  "Picnic",
  "Floor",
  "Plant",
  "Hang",
  "Oil",
  "Itching",
  "Teeth",
  "Glass",
  "Bottle",
  "Tools",
  "Bathroom",
  "Coffee",
  "Vegan",
  "Drink",
  "Art",
  "Drawing",
  "Seashell",
  "Painting",
  "Shape",
  "Knots",
  "Rope",
  "Emergency",
  "Carry",
  "Sewing",
  "Knotsmanly",
  "Suit",
  "Gift",
  "Face mask",
  "Virus",
  "Corona",
  "Seal",
  "Manly",
  "Science",
  "Car",
  "Charger",
  "Battery",
  "Magnet",
  "Compass",
  "Slime",
  "Slime",
  "Satisfying",
  "Kids",
  "Ball",
  "Bouncy",
  "Computer",
  "Egg",
  "Water",
  "Paper plate",
  "Toilet roll",
  "Trick",
  "Squeeze",
  "Salad",
  "Dip",
  "",
  "Seperate",
  "Funnel",
  "Roll",
  "Peel",
  "Flower",
  "Calcium",
  "Watering.",
  "Sharpen",
  "Knives",
  "Egg shell",
  "Boil",
  "Tongs",
  "Facial",
  "Mask",
  "Paper towel",
  "Moisturize",
  "Toothpick",
  "String",
  "Zig zag",
  "Freeze",
  "Preping",
  "Cook",
  "Cement",
  "Decor",
  "Candle",
  "Mold",
  "Pot",
  "Upgrade",
  "Organize",
  "Clean",
  "Life hack",
  "Weight",
  "Pencil case",
  "Chair",
  "Gadgets",
  "Cooking",
  "Collector",
  "Trash bin",
  "Toilet",
  "Lift",
  "Fruit",
  "Lunch box",
  "Vegetable",
  "Dough",
  "Glue gun",
  "Finger",
  "Can",
  "Storage",
  "Slicer",
  "Supplies",
  "Flexible",
  "Stress",
  "Loose",
  "Silicone",
  "Crayon",
  "Cut",
  "Bracelet",
  "Screw",
  "Wood",
  "Wire",
  "Connection",
  "Measurement",
  "Electricity",
  "Binder clip",
  "Picture",
  "Book",
  "Tab",
  "Reading",
  "Dividers",
  "Cover",
  "Toiletries",
  "Electricity",
  "Pumpkin",
  "Vegetables",
  "Acetone",
  "Polystyrene",
  "Melt",
  "Soap",
  "Motion",
  "Water",
  "Balloon",
  "Forces",
  "Fluid",
  "Newtonian",
  "Banana",
  "DNA",
  "Soap",
  "Filter",
  "Alcohol",
  "Extract",
  "Ice",
  "Gas",
  "Sodium",
  "Absorbs",
  "Gell",
  "Balls",
  "Bubbles",
  "Eye",
  "Glycerin",
  "Food coloring",
  "Glycerol",
  "Heat",
  "Droplet",
  "School",
  "Math",
  "Puzzle",
  "Temperature",
  "Dance",
  "Food",
  "Cookie",
  "Muffin",
  "Pie",
  "Lifehacks",
  "Tape",
  "Hide",
  "Hideout",
  "Plaster",
  "Dust",
  "Matches",
  "Iron",
  "Bag",
  "Restoration",
  "Toy",
  "Pallet",
  "Garden",
  "Bicycle",
  "Shelves",
  "Holiday",
  "Christmas",
  "Mashup",
  "Bath",
  "Engagement",
  "Letter",
  "Stamps",
  "Postcard",
  "Lighting",
  "Lego",
  "Christmas tree",
  "Eco",
  "Manflake",
  "Gift",
  "Wrapping",
  "Candy",
  "Holiday",
  "Candle",
  "Drill",
  "Sharpening",
  "Smoothie",
  "Life hacks",
  "Nut",
  "Laser",
  "Airbag",
  "Unexpected",
  "Glowing",
  "Lemonade",
  "Hair",
  "Vase",
  "Books",
  "Shelf",
  "Gap",
  "Extraction",
  "Stickers",
  "Removal",
  "Stuck",
  "Dye",
  "Handy",
  "Cement",
  "Hole",
  "Broken",
  "Polish",
  "3Dpen",
  "Restoration",
  "Slippery",
  "Handy",
  "Laundry",
  "Game",
  "Chess",
  "Dirt",
  "Carpet",
  "Resin",
  "Crafts",
  "Cable",
  "Coaster",
  "Wardrobe",
  "Surface",
  "Pendant",
  "Necklace",
  "Housework",
  "Library",
  "Mini",
  "Backpack",
  "Prints",
  "Phone case",
  "Construction",
  "Foil",
  "Door",
  "Knobs",
  "Collect",
  "Glue",
  "Homemade",
  "Remove",
  "Ornament",
  "Bread",
  "Home",
  "Close",
  "Box",
  "Car",
  "Gadgets",
  "Wax",
  "Trash",
  "Trash bag",
  "Window",
  "Tire",
  "Scratch",
  "Seat",
  "Moving",
  "Protection",
  "Perfume",
  "Knife",
  "Travel",
  "Packing",
  "Luggage",
  "Laptop",
  "Stand",
  "Bedroom",
  "Lights",
  "Sofa",
  "Interior",
  "Resistant",
  "Notebook",
  "Instrument",
  "Massage",
  "Waffle",
  "Burger",
  "Fridge",
  "Ice cream",
  "Dispenser",
  "Sleeves",
  "Dishes",
  "Cheese",
  "Meat",
  "Cupcake",
  "Lighter",
  "Fan",
  "Vacuum cleaner",
  "Noodles",
  "Fish",
  "Peeler",
  "Nuts",
  "Grill",
  "Oven",
  "Dinner",
  "Pancakes",
  "Breakfast",
  "Juice",
  "Folding",
  "Travel",
  "Bed",
  "Plant",
  "Packing",
  "Technology",
  "Wires",
  "Organize",
  "Furniture",
  "Iron",
  "Stain",
  "Makeup",
  "Pet",
  "Dog",
  "Sandwich",
  "Vacuum",
  "Armchair",
  "Makeover",
  "Cande",
  "Romantic",
  "Pizza",
  "Hotglue",
  "Stove",
  "Repair",
  "Kombucha",
  "Foam",
  "Music",
  "Games",
  "Magic",
  "Tricks",
];

export const videoTypes = ["Compilation", "Process", "UGC"];
